/** Shared copy for “waiting on model / tools” status lines in the Vibe thread UI. */
export const VIBE_THINKING_FALLBACK = "Thinking...";

export const getVibeStreamingStatusLine = (inFlightLabel: string | null) =>
  inFlightLabel ? `${inFlightLabel}…` : VIBE_THINKING_FALLBACK;
